<div class="nav-header">
  <span>{{ 'VIEW.SHARED_VIEW' | translate | uppercase }}</span>
</div>
<div class="nav-list">
  @for (item of navItems; track item) {
    <div class="nav-item-wrapper">
      <div class="nav-item" [class.active]="item.sectionId === activeSectionId">
        <div class="nav-item-inner">
          <div class="nav-indicator"></div>
          <a (click)="scrollToSection(item.sectionId)">{{ item.labelKey | translate }}</a>
        </div>
      </div>
    </div>
  }
</div>
